import SocialIcon from 'components/icons/social-icons'
import Image from 'components/Image'
import { PageSEO } from 'components/SEO'
import { Author } from 'contentlayer/generated'
import { ReactNode } from 'react'

interface Props {
  children: ReactNode
  content: Author
}

export default function AuthorLayout({ children, content }: Props) {
  const { name, avatar, occupation, company, email, twitter, linkedin, github } = content

  return (
    <>
      <PageSEO
        title={`About - ${name}`}
        description={`Details of my life and my journey as software engineer`}
      />
      <div className="divide-y">
        <div className="pt-6 pb-8 space-y-2 md:space-y-5" data-aos="zoom-in-down">
          <h1 className="text-3xl font-extrabold leading-9 tracking-tight text-gray-900 dark:text-gray-100 sm:text-4xl sm:leading-10 md:text-6xl md:leading-14">
            About
          </h1>
        </div>
        <div className="items-start space-y-2 xl:grid xl:grid-cols-3 xl:gap-x-8 xl:space-y-0">
          <div className="flex flex-col items-center pt-8 space-x-2">
            <Image
              src={avatar}
              alt={`${name} profile picture`}
              width="192"
              height="192"
              className="w-48 h-48 object-cover object-top rounded-full"
            />
            <h3
              className="pt-4 pb-2 text-2xl font-bold leading-8 tracking-tight"
              data-aos="slide-up"
            >
              {name}
            </h3>
            <div
              className="text-gray-500 dark:text-gray-400"
              data-aos="slide-up"
              data-aos-delay="50"
            >
              {occupation}
            </div>
            <div
              className="text-gray-500 dark:text-gray-400"
              data-aos="slide-up"
              data-aos-delay="100"
            >
              {company}
            </div>
            <div className="flex pt-6 space-x-3" data-aos="zoom-in" data-aos-delay="150">
              <SocialIcon kind="mail" href={`mailto:${email}`} />
              <SocialIcon kind="github" href={github} />
              <SocialIcon kind="linkedin" href={linkedin} />
              <SocialIcon kind="twitter" href={twitter} />
            </div>
          </div>
          <div className="pt-8 pb-8 prose dark:prose-dark max-w-none xl:col-span-2" data-aos="fade">
            {children}
          </div>
        </div>
      </div>
    </>
  )
}
